import React from 'react';
import styled from 'styled-components';
import { mediaQuery } from '@99designs/emu/css';
import { spaces } from '@99designs/emu/settings';

interface Props {
    side: React.ReactNode;
    top: React.ReactNode;
    bottom: React.ReactNode;
    variations?: string[];
}

export default function ContentSideFeature({ side, top, bottom }: Props) {
    return (
        <ContentSideFeatureContainer>
            <ContentSideFeatureSide>{side}</ContentSideFeatureSide>
            <ContentSideFeatureTop>{top}</ContentSideFeatureTop>
            <ContentSideFeatureBottom>{bottom}</ContentSideFeatureBottom>
        </ContentSideFeatureContainer>
    );
}

const ContentSideFeatureContainer = styled.div`
    display: grid;
    grid-template-rows: auto;
    grid-template-columns: 55% 45%;

    ${mediaQuery.minimum('normal')} {
        grid-template-areas:
            'side-container .'
            'side-container top-container'
            'side-container bottom-container'
            'side-container .';
    }

    ${mediaQuery.only('medium')} {
        grid-template-columns: 50% 50%;
        grid-template-areas:
            'top-container top-container'
            'side-container bottom-container'
            'side-container bottom-container';
    }

    ${mediaQuery.only('small')} {
        grid-template-columns: 1fr;
        grid-template-areas:
            'top-container'
            'side-container'
            'bottom-container';
    }
`;

const ContentSideFeatureSide = styled.div`
    grid-area: side-container;
    text-align: right;
    padding-right: ${spaces['2bu']};

    ${mediaQuery.minimum('medium')} {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;

const ContentSideFeatureTop = styled.div`
    grid-area: top-container;
`;

const ContentSideFeatureBottom = styled.div`
    grid-area: bottom-container;

    ${mediaQuery.only('medium')} {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
`;
